import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

// route modules
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import { getPersonsSelector } from 'store/modules/persons/selectors'
import { isImpersonating } from 'store/modules/user-session/selectors'
import DentalCoverageModal from '../components/DentalCoverageModal'
import { actions, constants, selectors } from '../modules/dental-coverage'

const mapStateToProps = (state, props) => {
  const persons = selectors.getAllPersons(state)
  const { Person: person } = getPersonsSelector(state)
  const fields = persons.map((p) => p.Id)

  const initialValues = {}
  selectors.getSelectedPersons(state).forEach((person) => {
    initialValues[person.Id] = true
  })

  return {
    isProcessing: getWaiter(state, constants.GET_DENTAL_PLANS).isPending,
    persons,
    fields,
    initialValues,
    isImpersonated: isImpersonating(state),
    isTestUser: person?.IsTestUser,
    isActivityLogEnabled: props?.flags['enrollme.activity-log-reason-popup-enabled'],
  }
}

const mapDispatchToProps = (dispatch) => ({
  onCancelClick: () => dispatch(clearModal()),
  onSubmit: (values, dispatch, props) => {
    const { isImpersonated, isTestUser, isActivityLogEnabled } = props

    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      const activityLogOptions = {
        reason,
        reasonCategory,
        zendeskTicket,
      }

      return new Promise((resolve, reject) => {
        const selectedIds = Object.keys(values).reduce((prev, curr) => {
          if (values[curr]) prev.push(curr)
          return prev
        }, [])
        dispatch(actions.setSelectedPersons(selectedIds))
        dispatch(actions.updateDentalPlansWithCart()).then(
          () => {
            logGenericActivity({
              additionalData: {
                values,
                ...activityLogOptions,
              },
              activity: 'edited dental coverage persons',
              action: ShopForHealthAction.EditDentalCoveragePersons,
            })
            dispatch(clearModal())
            resolve()
          },
          () => {
            reject()
          }
        )
      })
    }

    handleActivityLogPopup({
      isImpersonated,
      isTestUser,
      isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to edit dental coverage persons?',
      onSubmit: callback,
    })
  },
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(DentalCoverageModal))
